<template>
  <div id="">

    <v-row no-gutters>
      <v-col>
        <v-progress-linear :active="loadingData" color="accent" :indeterminate="true" ></v-progress-linear>
      </v-col>
    </v-row>


    <v-card class="d-print-none pa-1" v-show="camposOptions.length > 2">
        <v-row dense>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-select
            style="max-width: 200px"
            outlined
            dense
            hide-details
            v-model="campoSelected"
            item-text="label"
            return-object
            :items="camposOptions"
            label="Campos"
            ></v-select>
          </v-col>

        <v-col cols="auto" >
          <v-btn @click="reloadData()"  color="accent">cargar</v-btn>
        </v-col>

        </v-row>
    </v-card>


  <div class="d-print-flex d-none justify-space-between header-print ">
    <div v-show="camposOptions.length > 2 || campoSelected !== nullItem">
    Campo: {{campoSelected.label}}
    </div >
  </div >





    <v-card v-for="(dataTable, index) in dataTableArray" :key="index" class="table-card mx-md-3 my-md-3" :class="{'mb-md-9':dataTableArray.length > 1}">
      <v-card-title primary-title class="pb-0 pt-1 pl-2" v-show="dataTableArray.length > 1">
        <div>
          <span class="text-h6 mb-0">{{dataTable.title}}</span>
        </div>
      </v-card-title>

      <ag-table
      :isFullHeight="dataTableArray.length == 1"
      class="ag-table-libro-remuneraciones"
      :style="[{'max-height': dataTableArray.length == 1 ? '':'500px'}]"
      :data-table="dataTable.data"
      v-show="dataTable.data.length > 0"
      sidebar-clickeable
      :with-totals-footer="true"
      @click-sidebar="showTrabajadorDialog"
      :with-sidebar-extended="false"
      :config="tableConfig"></ag-table>

    </v-card>

      <v-alert
        border="left"
        colored-border
        type="warning"
        icon="warning"
        elevation="2"
        v-if="dataTableArray.length == 1 && dataTableArray[0].data.length == 0"
        v-show="!loadingDate"
        class="ma-4">
        Sin datos para mostrar
      </v-alert>





    <list-tarja-dialog
    v-model="showedTrabajadorDialog"
    :trabajador="trabajadorDialog"
    :dates="datesDialog"
    :fullscreen="isMobile"
    @change="getData()">
  </list-tarja-dialog>




  </div>
</template>
<script>

import agTable from "@/components/agTable";
import remuneracionesModel from "@/models/remuneracionesModel";
import trabajadorModel from "@/models/trabajadorModel";
import axios from "axios";
import moment from "moment";
import listTarjaDialog from "@/components/listTarjaDialog";
import asistencia from "@/views/asistencia"
import XLSX from 'xlsx';
import campoModel from "@/models/campoModel";
import _ from "lodash";

export default {
  name: "libroRemuneraciones",
  components: {
    agTable,
    listTarjaDialog,
    asistencia
  },
  props: {
    trabajadores: {default:()=>[]},
    contratistas: {default:()=>[]},
    dates:{},
  },
  data : () => ({
    tableConfig    : {
      header       : [
        {
          label    : "Jornadas",
          print    : "Jor",
          mobile   : "Jornadas",
          value    : "jornadas",
          round: 2,
          tooltip  : "La Suma de jornadas del mes",
          print_width: "xs"
        },

        {
          label    : "Jornadas a Dia",
          print    : "Jor x Dia",
          mobile   : "Jor x Dia",
          value    : "jornadas_dia",
          round: 2,
          tooltip  : "La Suma de jornadas al dia del mes",
          print_width: "xs"
        },


        {
          label    : "Valor total Dia",
          print    : "$ x Dia",
          mobile   : "$ x Dia",
          value    : "suma_dia",
          round    : 0,
          prefix   : "$ ",
          currency : true,
          tooltip  : "Suma de costos de cada tarja al dia dentro del mes",
          print_width: "lg"
        },




        {
          label    : "Jornadas a Trato",
          print    : "Jor x Trato",
          mobile   : "Jor x Trato",
          value    : "jornadas_trato",
          tooltip  : "La Suma de jornadas a trato del mes",
          print_width: "xs"
        },

        /*
        {label   : "Suma de Cantidad",
        value    : "rendimiento",
        tooltip  : "Suma del rendimiento de cada tarja dentro del mes"},
        */

        {
          label    : "Valor total Trato",
          print    : "$ x Trato",
          mobile   : "$ x Trato",
          value    : "suma_trato",
          round    : 0,
          prefix   : "$ ",
          currency : true,
          tooltip  : "Suma de costos de cada tarja a trato dentro del mes",
          print_width: "lg"
        },


        /*
        {label   : "Promedio de Valor Trato",
        value    : "promedio_trato",
        round    : 2,
        prefix   : "$ ",
        currency : true,
        tooltip  : "Promedio de costos de cada tarja dentro del mes"},
        */

        {
          label    : "Suma de Bonos",
          print    : "Sum Bonos",
          mobile   : "Sum Bonos",
          value    : "suma_bonos",
          prefix   : "$ ",
          round: 0,
          currency : true,
          tooltip  : "Suma del bonos de cada tarja dentro del mes",
          print_width: "lg"
        },

        {
          label    : "Total horas extras",
          print    : "Total hrs extras",
          mobile   : "Total hrs extras",
          value    : "cantidad_horas_extras",
          suffix   : " hrs",
          //currency : true,
          tooltip  : "Suma del horas extras de cada tarja dentro del mes",
          print_width: "xs"
        },

        {
          label    : "$ total horas extras",
          print    : "$ hrs extras",
          mobile   : "$ hrs extras",
          value    : "suma_horas_extras",
          prefix   : "$ ",
          currency : true,
          round    : 0,
          tooltip  : "Suma de costos por horas extras de cada tarja dentro del mes",
          print_width: "lg"
        },

        {
          label    : "Semana Corrida",
          print    : "Semana corrida",
          mobile   : "SC",
          value    : "semana_corrida",
          prefix   : "$ ",
          currency : true,
          round    : 0,
          tooltip  : "Semana Corrida",
          print_width: "lg"
        },
        {
          label    : "Liquido",
          print    : "Liquido",
          mobile   : "Liquido",
          value    : "liquido",
          prefix   : "$ ",
          currency : true,
          round    : 0,
          tooltip  : "Suma del total lisuqido de cada tarja dentro del mes",
          print_width: "lg"
        },
      ],
      sidebar      : {
        title      : "Trabajadores",
        label      : "trabajador_name"
      }
    },
    dateSelected   : moment().format("YYYY-MM-DD"),

    dateMenuMonth       : false,
    //dateMenuInicio      : false,
    //dateMenuFin         : false,

    datesDialog  : { // para dialogo de tarjas de trabajador
      dateInicio  : moment().startOf('month').format("YYYY-MM-DD"),
      dateFin     : moment().endOf('month').format("YYYY-MM-DD"),
      //dateMonth   : moment().startOf('month').format("YY-MM"),
    },
    /*
    dates: {
      dateInicio  : moment().startOf('month'),
      dateFin     : moment().endOf('month'),
      dateMonth   : moment().startOf('month').format("YY-MM"),
    },
    */
    //dataTable    : [],
    dataTableArray : [],
    //trabajadores : [],
    data         : [],
    loadingData  : false,
    showedTrabajadorDialog : false,
    trabajadorDialog: null,

    campos       : [],
    camposOptions: [],
    campoSelected: null,
    camposMenu   : false,
  }),
  created() {
  },
  computed:{
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    isMobile(){
      return this.$store.getters.isMobile;
    },
  },
  watch:{
    empresaSelected(){
          this.getData();
    },
    dates(){
      console.log("change dates");
      this.changeDates();
    },
    group(){
      console.log("group changed");
      this.prepareData();
    }
  },
  created() {
    this.changeDates();
    //this.getData();
  },
  methods: {

    changeDates(){
      this.datesDialog  = {
        dateInicio : this.dates.dateInicio.format("YYYY-MM-DD"),
        dateFin    : this.dates.dateFin.format("YYYY-MM-DD")
        //dateMonth  : dates.dateInicio.format("YY-MM")
      };
      this.dateSelected = this.dates.dateInicio.format("YYYY-MM-DD")
      this.getData();
    },
    showTrabajadorDialog(params){
      this.trabajadorDialog = params.item.trabajador;
      this.hideTrabajadorDialog();
      this.showedTrabajadorDialog = true;
    },
    hideTrabajadorDialog(){
      this.showedTrabajadorDialog = false;
    },
    getData(){
      this.loadingData = true;
      var promises     = [
        //this.getTrabajadores(),
        this.getDataTotales(),
        this.getCampos(),
      ];
      axios.all(promises).then(resArray =>{
        this.prepareData();
        this.loadingData = false;
      })
    },
    reloadData(){
      this.loadingData = true;
      var promises     = [
        this.getDataTotales(),
      ];
      axios.all(promises).then(resArray =>{
        this.prepareData();
        this.loadingData = false;
      })
    },
    prepareData(){
        this.dataTableArray = [];
        var groups = [
          {label:"Empresa", path:"empresa"},
          {label:"por contratista", path:"contratista", hasMany: true},
        ];

      _.forEach(groups, (group) => {
        var data = this.data[group.path];
        if(group.hasMany ){
          _.mapValues(data, (val, id)=>{
            var contratista = _.find(this.contratistas, {id: parseInt(id)});
            _.forEach(val, item => {
              item.trabajador      = _.find(this.trabajadores, {id: item.trabajador_id});
              item.trabajador_name = item.trabajador.nombre;
            })
            this.dataTableArray.push({data:val, title:contratista ? contratista.nombre : '--'});
          })
        }else{
          _.forEach(data, item => {
            item.trabajador      = _.find(this.trabajadores, {id: item.trabajador_id});
            item.trabajador_name = item.trabajador.nombre;
          })
          this.dataTableArray.push({data:data, title: group.label});
        }
      });

      this.$forceUpdate();
    },



    getCampos(){
      if(this.empresaSelected == null) return;
      var p = campoModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }});
      p.then(res => {
        this.campos =  res.data.data;
        this.camposOptions = _.map(this.campos, c => {
          return {
            val: c,
            label: c.nombre
            }
        })
        this.camposOptions.unshift({
          val: null,
          label: "Todos los Campos"
        });
        this.campoSelected = _.first(this.camposOptions);
      }, resError =>{
        console.error(resError);
      });
      return p;
    },

    getDataTotales() {
      var params = {
        empresa_id: this.empresaSelected.id,
        fecha: this.dateSelected
      }

      if(this.campoSelected && this.campoSelected.val ){
        params.campos_id = [this.campoSelected.val.id];
      }

      return remuneracionesModel.all({params}).then(res => {
        this.data       = res.data.data;
      });
    },



    downloadXls(name){
      const fileName = name || "archivo";
      const workbook = XLSX.utils.book_new();
      _.forEach(this.dataTableArray, dta => {

        let headerVars = _.clone(this.tableConfig.header);
        headerVars.unshift({
          label:"Nombre",
          value: "trabajador_name",
          xls:{wpx:250}
        });
        let xlsDefault = {wpx:100};

        let header = _.map(headerVars, h => h.label);
        let dataAoA = _.map(dta.data, d=>{
          return _.map(headerVars, h => {
            return d[h.value];
          })
        });
        dataAoA.unshift(header);

        let sheet = XLSX.utils.aoa_to_sheet(dataAoA);

        let sheetName = (dta.title.length > 30) ? dta.title.substr(0, 29) : dta.title;

        //agrega numeros al final del nombre en el caso de existir nombres repetidos
        var x = 2;
        while(_.indexOf(workbook.SheetNames, sheetName) > -1){
          sheetName = sheetName.substr(0, 26)+ "_"+x;
          x++;
        }

        sheet["!cols"] = _.map(headerVars, h => h.xls || xlsDefault);
        XLSX.utils.book_append_sheet(workbook,sheet,sheetName);

      })
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }



    /*
    getTrabajadores(){
      return trabajadorModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }}).then(res => {
        this.trabajadores = res.data.data;
        _.forEach(this.trabajadores, tr => {
          tr.codname = tr.nombre;
          if(tr.codigo && tr.codigo.length > 1){
            tr.codname = tr.codigo;
          }
        })
      }, resError =>{
        console.error(resError);
      });
    },
    */

  }
}
</script>
<style lang="scss" >
@media print{
  .table-card{
    box-shadow: none !important;
    page-break-inside: avoid;
    border: 1px solid grey !important;
    margin-bottom: 36px;
  }
  .ag-table-libro-remuneraciones{
    max-height: unset !important;
    margin-bottom: 8px;
  }
}
.table-card{
  .ag-table.full-height{
     height: calc(100vh - 160px) !important;
  }
}

.header-print{
  margin: 8px 8px 16px 8px;
}
</style>
